import React from "react"
import cookie from 'react-cookies'
import { Modal } from "react-bootstrap"

import { updatePhone } from "../../model/profile"

import { commonErr } from "../common/errors"

import { CustomOnlyInput } from "../components/input"


export default class ChangePhone extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 0, //0: show update 1: show update message 2: show confirm message
            ip_newphone: null,
            err: commonErr.INNIT,
            errMsg: ""
        }

    }

    handleInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    onSubmitBtnClick = (event) => {
        const newPhone = this.state.ip_newphone;

        updatePhone(newPhone).then((resp) => {
            this.setState({
                step: 1,
                err: resp.data.error,
                errMsg: resp.data.errorMessage
            });

            if (resp.data.error >= commonErr.SUCCESS) {
                //GA
                const utmSrc = cookie.load("_utm_src") || "web_directly";
                const utmExt = cookie.load("_utm_ext") || "no_label";
                window.ga('send', 'event', utmSrc, "VERIFY_PHONE_SUCCESS", utmExt);
                                    
            }
        });
    }

    onVerifyBtnClick = () => {
        this.props.showVerifyPhoneOpt()
        this.props.hideModal()

    }

    onBackBtnClick = () => {
        this.setState({
            step: 0,
            err: commonErr.INNIT,
            errMsg: ""
        });
    }

    closeForm = () => {
        this.setState({
            step: 0,
            err: commonErr.INNIT,
            errMsg: ""
        });
        if (this.state.err >= commonErr.SUCCESS && this.state.err !== commonErr.INNIT && this.state.err !== commonErr.LOADING) {
            this.props.getProfile();
        }
        this.props.hideModal();
    }

    render() {
        var content;
        if (this.state.step === 1) {
            if (this.state.err >= commonErr.SUCCESS) {
                content = <div className="modal-confirm-body">
                    <div className="line-form">
                        <div className="textAlign-center"><i className="ic ic-verify"></i> Cập nhật thành công.</div>
                    </div>
              
					<button className="btn btn-primary btn--m" type="button" onClick={this.onVerifyBtnClick}>Xác minh ngay</button>
									
                </div>
            } else {
                content = <div className="modal-confirm-body">
                    <div className="line-form">
                        <div className="textAlign-center"><i className="ic ic-error"></i> Cập nhật thất bại. {this.state.errMsg}</div>
                    </div>
                
                    <button className="btn btn-primary btn--m" type="button" onClick={this.onBackBtnClick}>Thử lại</button>
                </div>
            }
        } else {
            content = <div className="modal-confirm-body">
                        <CustomOnlyInput name={"ip_newphone"} placeholder={"Số điện thoại"} onChange={this.handleInputChange}/>
                        {/* <div className="custom-input">
                            <div className="wrap-input">
                                <input type="text" name="ip_newphone" placeholder="Số điện thoại" onChange={this.handleInputChange} />
                            </div>
                        </div> */}
                        <div className="wrap-btn has-2-btn">
                            <button className="btn btn-primary btn--m" type="button" onClick={this.onSubmitBtnClick}>Cập nhật</button>
                        </div>
                    </div>
                }

        return <Modal
            show={this.props.show}
            onHide={this.closeForm}
            dialogClassName="modal-s modal-dialog modal-confirm"
        >
            <Modal.Header closeButton={true} closeLabel={""}>
                <h5>Cập nhật số điện thoại</h5>
            </Modal.Header>
            <Modal.Body>
                {content}
            </Modal.Body>
			</Modal>
				
    }
}
